export default __webpack_public_path__ + "fa76c14e49fd2a426d749233599b2684.svg";